
import { mapState } from 'vuex'
import captcha from '@/utils/captcha.js'
import {temporary,processDataAndSave} from "@/utils/cookieOperation.js"
export default {
  props: {
    waybillNo: {
      type: String,
    },
    operateType: {
      type: String,
    },
  },
  computed: {
    ...mapState({
      locale: (state) => state.locale,
      site: (state) => state.site,
      phoneCodeList: (state) => state.support.applyPhoneCodeOptions,
    }),
    // 获取当前手机验证码读秒时间
    getMobileSecondsText() {
      return this.mobileCount === this.maxCount
        ? this.$t('common.verification.getCode')
        : this.$t('common.verification.remainReFetch', [this.mobileCount])
    },
    // 手机区号列表
    //     mobileAreaCodeList() {
    //       console.log('手机区号列表222---', this.phoneCodeList );
    //   if( this.phoneCodeList ){
    //     return this.phoneCodeList.map((item) => {
    //       return {
    //         countryCode: item.countryCode,
    //         countryName: item.countryName,
    //         countryNameI18n: item.countryNameI18n,
    //         phoneCode: item.phoneCode,
    //         phoneDisplayCode: `+${item.phoneCode}`,
    //       }
    //     })
    //   } else {
    //     return []
    //   }
    // },
    // 获取当前手机区号
    curPhoneCode() {
      const matchedItem = this.mobileAreaCodeList.find(
        (item) => item.countryCode === this.form.countryCode
      )
      return matchedItem?.phoneCode || ''
    },
    curVerifyPhoneCode() {
      const matchedItem = this.mobileAreaCodeList.find(
        (item) => item.countryCode === this.verifyForm.countryCode
      )
      return matchedItem?.phoneCode || ''
    },
    customerType() {
      return this.$route.query.customer_type || ''
    },
    channel() {
      return this.customerType === 'samsung' ? 2 : 3
    },
    isSgSite() {
      return this.site.toUpperCase() === 'SG'
    },
    applTemporaryData(){
      return this.$store.state.support.applTemporaryData
    },
  },
  data() {
    const maxCount = 60
    let validator = (rule, value, callback) => {
      if (!value) {
        callback(
          new Error(
            this.$t(
              'serviceSupport.clearanceService.certificateQuery.mobileCodePlaceholder'
            )
          )
        )
      } else {
        const reg = /^\d{6}$/.test(value)
        if (!reg) {
          this.$message.error(
            this.$t(
              'serviceSupport.clearanceService.certificateQuery.verificationCodeTip'
            )
          )
          callback(
            new Error(
              this.$t(
                'serviceSupport.clearanceService.certificateQuery.verificationCodeTip'
              )
            )
          )
        }
        // return reg
        callback()
      }
    }
    // 异步校验函数返回 Promise
    let asyncValidator = (rule, val, callback) => {
      if (!val) {
        callback(
          new Error(
            this.$t(
              'serviceSupport.clearanceService.certificateQuery.mobilePlaceholder'
            )
          )
        )
      } else {
        this.checkPhone((res) => {
          if (!res) {
            callback(
              new Error(
                this.$t(
                  'serviceSupport.clearanceService.certificateQuery.mobileTip'
                )
              )
            )
          } else {
            callback()
          }
        })
      }

      // return new Promise((resolve) => {
      //   if (!val) {
      //     this.$message.error(this.$t(
      //          'serviceSupport.clearanceService.certificateQuery.mobilePlaceholder'
      //     ))
      //     resolve(false)
      //     return
      //   }
      //   this.checkPhone((res) => {
      //     if (!res) {
      //       this.$message.error(this.$t(
      //           'serviceSupport.clearanceService.certificateQuery.mobileTip'
      //       ))
      //     }
      //     resolve(res)
      //   })
      // })
    }
    return {
      maxCount,
      mobileCount: maxCount, // 60s
      dialogVisible: false,
      verifyForm: {
        countryCode: '',
        phoneCode: '', // 区号
        phoneNumber: '', // 手机号
      },
      queryForm: {
        countryCode: '',
        phoneCode: '', // 区号
        phoneNumber: '', // 区号
        creationTime: [],
      },
      layout: 'vertical',
      rules: {
        phoneNumber: [
          // {
          //   required: true,
          //   message: this.$t(
          //     'serviceSupport.clearanceService.certificateQuery.mobilePlaceholder'
          //   ),
          //   trigger: 'blur',
          // },
          {
            required: true,
            validator: asyncValidator,
            trigger: 'change',
          },
        ],
        validateCode: [
          {
            required: true,
            message: this.$t(
              'serviceSupport.clearanceService.certificateQuery.mobileCodePlaceholder'
            ),
            trigger: 'blur',
          },
          {
            validator: validator,
            trigger: 'blur',
          },
        ],
      },
      isBtnDisabled: true,
      isMobileBtnLoading: false,
      maxCount,
      mobileCount: maxCount, // 60s
      isNextLoading: false,
      form: {
        mobile: '',
        mobileCode: '',
        businessType: '3', // 业务场景
        app: 'waybill', // 顺丰滑块需要
        countryCode: 'CN', // 手机默认国家,手机区号可能相同，故取国家二字码
      },
      mobileAreaCodeList: [],
      timer: null,
      mobileTimer: null,
    }
  },
  created() {
    if (process.client) {
      captcha.init({ lang: this.locale, app: this })
      // this.initPhoneCode()
    }
    // 拷贝查询区域的数据到弹窗
    // this.transferData('in')
    this.fetchMobileAreaCodeList()
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    if(this.timer){
      clearTimeout(this.timer)
    }
    // 清理所有定时器
    if (this.mobileTimer) {
      clearInterval(this.mobileTimer)
    }
  },
  methods: {
    // 获取手机区号列表
    async fetchMobileAreaCodeList() {
      try {
        const res = await this.$API.support.getCustomsDeclareCountryListApi({},{
          headers:this.applTemporaryData||{}
        })
        this.mobileAreaCodeList = res.map((item) => {
          return {
            countryCode: item.countryCode,
            countryName: item.countryName,
            countryNameI18n: item.countryNameI18n,
            phoneCode: item.phoneCode,
            value: `${item.countryCode}`,
            label: `${item.countryNameI18n} +${item.phoneCode}`,
          }
        })
        // 默认展示当前站点手机区号
        const matchedItem = this.mobileAreaCodeList?.find(
          (i) => i.countryCode === this.site.toUpperCase()
        )
        this.form.countryCode = matchedItem?.countryCode || 'CN'
      } catch (e) {
        console.log(e)
      }
    },
    init() {
      this.getCookie()
    },
    // 中国内地默认+86
    initPhoneCode() {
      // if (this.site === 'cn') {
      this.queryForm.countryCode = 'CN'
      // }
    },
    async getCookie() {
      const phoneCodeList =
        await this.$API.support.getCustomsDeclareCountryListApi()
      this.$store.commit('support/SET_APPLY_PHONE_CODE_OPTIONS', phoneCodeList)
      // let info = getCookie(COOKIE_PHONE_KEY) || {}
      // if (typeof info === 'string') {
      //   info = JSON.parse(info)
      //   const newInfo = this.handleResetDate(info?.condition)
      //   this.queryForm = { ...this.queryForm, ...newInfo }
      //   removeCookie(COOKIE_PHONE_KEY)
      //   this.$nextTick(() => {
      //     this.querySubmit()
      //     this.renderForm(this.queryForm)
      //   })
      // }
    },
    // 过滤
    filterOption(input, option) {
      const key = option?.data?.key || ""
      return key.toLowerCase()?.includes((input || '').toLowerCase())
    },
    handleFetchCode() {
      this.$refs.verifyFormRef.validateField(['phoneNumber'], (errMessage) => {
        if (!errMessage) {
          // 唤起滑块
          captcha.verify().then((res) => {
              this.sendSms(res)
            })
            .catch((error) => {
              console.error('Captcha verification failed:', error)
              this.$message.error(this.$t('common.http.networkError'))
            })
        }
      })
    },
    // 手机号发送
    async sendSms(options) {
      const params = {
        businessType: this.operateType == 1 ? '3' : '4', // 业务场景
        country: this.form.countryCode, // 国家二字码
        phoneCode: this.curPhoneCode, // 区号
        phoneNumber: this.form.phoneNumber, // 手机号
        sfWaybillNo: this.waybillNo ? this.waybillNo : route.waybillNo, // 运单号
        // sfWaybillNo: 'SF1020135784589',
        app: this.form.app, // 标记(顺丰滑块验证)
        ...options,
      }
      try {
        this.isMobileBtnLoading = true
        const res = await this.$API.support.sendSmsApi(params)
        this.isMobileBtnLoading = false
        if (res) {
          this.isBtnDisabled = false
          this.readSeconds()
          this.$message.success(
            this.$t(
              'serviceSupport.clearanceService.certificateQuery.verificationSuccess'
            )
          )
        }
      } catch (e) {
        this.isMobileBtnLoading = false
        console.error(e)
      }
    },
    // 读秒
    readSeconds() {
      const sendType = 'mobile'
      // 60s 倒计时
      this[`${sendType}Count`]--
      
      if (this[`${sendType}Timer`]) {
        window.clearInterval(this[`${sendType}Timer`])
      }
      
      this[`${sendType}Timer`] = window.setInterval(() => {
        this[`${sendType}Count`]--
        if (this[`${sendType}Count`] === 0) {
          if (this[`${sendType}Timer`]) {
            window.clearInterval(this[`${sendType}Timer`])
            this[`${sendType}Timer`] = null
          }
          this[`${sendType}Count`] = this.maxCount
        }
      }, 1000)
    },
    // 手机号校验
    async checkPhone(callback) {
      const params = {
        countryCode: this.form.countryCode, // 国家二字码
        phoneCode: this.curPhoneCode, // 区号
        phoneNumber: this.form.phoneNumber, // 手机号
      }
      try {
        const res = await this.$API.support.checkPhoneApi(params)
        callback(res)
      } catch (e) {
        console.log(e)
      }
    },
    // 统一手机号，区号
    transferData(type) {
      // 筛选区手机号，区号到弹窗区
      if (type === 'in') {
        const { phoneCode, phoneNumber, countryCode } = this.queryForm
        this.verifyForm = Object.assign(this.verifyForm, {
          phoneCode,
          phoneNumber,
          countryCode,
        })
      } else {
        const { phoneNumber, countryCode } = this.verifyForm
        this.queryForm = Object.assign(this.queryForm, {
          phoneCode: this.curVerifyPhoneCode,
          phoneNumber,
          countryCode,
        })
      }
    },
    verifySubmit() {
      this.$refs.verifyFormRef.validate((valid) => {
        if (valid) {
          if (this.operateType == 1) {
            // 预约日期
            this.onSubmit()
          } else {
            // 修改收件人
            this.onUpDataSubmit()
          }
        }
      })
      // this.onSubmit();
    },
    async onSubmit() {
      const params = {
        serviceCodes: '5,7', // 验证时只存在5,7同时存在的情况
        waybillNo: this.waybillNo,
        phoneCode: this.curPhoneCode, // 区号
        phoneNumber: this.form.phoneNumber, // 手机号
        businessType: '3', // 业务场景  1: 通关证明文件查询 2: 发票申请 3: 预约派送日期/自取
        sendType: '1', // 发送场景  1: 短信  2: 邮箱
        validateCode: this.form.validateCode, // 验证码
        channel: this.channel,
      }
      if (this.channel === 2) {
        params.customerType = this.customerType
      }

      try {
        const res = await this.$API.support.recordsDirectiveApi(params);
        if(res){
        let data=processDataAndSave(res,temporary);
        this.$store.dispatch('support/setApplTemporaryData',data)
        }
        
        if (res?.records?.length > 0) {
          // this.$toast.clear()
          const item = res.records[0]
          switch (item.directiveStatus) {
            case 0:
            case 2:
            case 5:
            case 1: // 预约中
              this.$emit('success', {
                res,
                directiveStatus: 'appointmentResult',
                mobile: this.form.phoneNumber,
                cusId: res.records[0]?.cusId,
                curPhoneCode: this.curPhoneCode,
                validateCode: this.form.validateCode, // 验证码
              }) // appointmentResult代表进入选择预约结果页面
              // this.form.mobileCode = ''
              // this.showConfirm(res)
              this.showDialogVisible()
              break
            // case 2:
            //   // 您的修改收件人申请，已处理成功，将按照新信息进行派送
            //   this.showAlert(res)
            //   break
            default: // 需要异常提示
              // res?.msg &&
              //   this.$toast({
              //     message: res?.msg,
              //   })
              res?.msg && this.$message.error(this.$t(res?.msg))
              break
          }
        } else if (res?.records?.length === 0) {
          // this.$toast.clear()
          // 如果没有表示都可以预约
          this.$emit('success', {
            res,
            directiveStatus: 'appointmentSelect',
            mobile: this.form.phoneNumber,
            cusId: res.records[0]?.cusId,
            curPhoneCode: this.curPhoneCode,
            validateCode: this.form.validateCode, // 验证码
          }) // appointmentSelect代表进入选择预约页面
          this.showDialogVisible()
          // this.$emit('verifySubmit', true);
        }
        // this.trackFn()
      } catch (e) {
        console.error(e)
      }
    },
    async onUpDataSubmit() {
      const params = {
        serviceCodes: '11', // 验证时只存在5,7同时存在的情况
        waybillNo: this.waybillNo,
        phoneCode: this.curPhoneCode, // 区号
        phoneNumber: this.form.phoneNumber, // 手机号
        businessType: '4', // 业务场景  1: 通关证明文件查询 2: 发票申请 3: 预约派送日期/自取 4: 修改收件人信息
        sendType: '1', // 发送场景  1: 短信  2: 邮箱
        validateCode: this.form.validateCode, // 验证码
        channel: this.channel,
      }
      if (this.channel === 2) {
        params.customerType = this.customerType
      }
      try {
        const res = await this.$API.support.modifyReceiverDirectiveApi(params);
        if(res){
          let result = {};
        result=processDataAndSave(res,temporary)
        this.$store.dispatch('support/setApplTemporaryData',result)
        }
        
        if (res?.records?.length > 0) {
          // this.$toast.clear()
          const item = res.records[0]
          switch (item.directiveStatus) {
            case 0:
            case 1:
            case 5: // 正在预约中，可取消
              // this.$emit('success', {
              //   res,
              //   directiveStatus: 'appointmentResult',
              //   mobile: this.form.phoneNumber,
              // }) // appointmentResult代表进入选择预约结果页面
              this.form.mobileCode = ''
              this.showConfirm(res)
              break
            case 2:
              // 您的修改收件人申请，已处理成功，将按照新信息进行派送
              this.showAlert(res)
              break
            default: // 需要异常提示
              // res?.msg &&
              //   this.$toast({
              //     message: res?.msg,
              //   })
              res?.msg && this.$message.error(this.$t(res?.msg))
              break
          }
        } else if (res?.records?.length === 0) {
          // this.$toast.clear()
          // 如果没有表示都可以预约
          this.$emit('success', {
            res,
            directiveStatus: 'appointmentSelect',
            mobile: this.form.phoneNumber,
            cusId: res.records?.length ? res.records[0]?.cusId : null,
            curPhoneCode: this.curPhoneCode,
            validateCode: this.form.validateCode, // 验证码
          }) // appointmentSelect代表进入选择预约页面
          this.showDialogVisible()
          // this.$emit('verifySubmit', true);
        }
        // this.trackFn()
      } catch (e) {
        console.error(e)
      }
    },
    async cancelDirectiveApi(res) {
      if (!res.records?.length) return
      const item = res.records[0]
      const params = {
        cusId: item.cusId,
        waybillNo: this.waybillNo,
        phoneCode: this.curPhoneCode, // 区号
        validateCode: this.form.validateCode, // 验证码
        verifiedPhoneNumber: this.form.phoneNumber, // 手机号
        channel: this.channel,
      }
      // this.trackFn('cancel')
      // this.$toast.loading({
      //   loadingType: 'spinner',
      //   forbidClick: true,
      //   duration: 0,
      // })
      const res2 = await this.$API.support.cancelDirectiveApi(params,{
       headers:this.applTemporaryData||{}
      })
      // this.$toast.clear()
      this.$nextTick(() => {
        if (res2?.success) {
          // 取消成功
          this.$message.success(
            this.$t(
              'serviceSupport.querySupport.waybills.successCancelAppointment'
            )
          )
          // this.$toast({
          //   message: this.$t(
          //     'serviceSupport.querySupport.waybills.successCancelAppointment'
          //   ),
          // })
          // this.$router.go(-1)
          this.showDialogVisible()
          this.dialogVisible = false
        } else {
          // 取消失败
          // res2?.msg &&
          //   this.$toast({
          //     message: res2?.msg,
          //   })
          res2?.msg && this.$message.error(res2?.msg)
        }
      })
    },
    showConfirm(res) {
      let that = this
      this.$confirm({
        title: that.$t('common.prompt'),
        cancelText: that.$t('button.no'),
        okText: that.$t('button.yes'),
        okType: 'danger',
        content: res?.msg,
        // theme: 'round-button',
        onOk() {
          that.cancelDirectiveApi(res)
        },
        onCancel() {},
      })
    },
    showAlert(res) {
      this.$confirm({
        title: this.$t('common.prompt'),
        cancelText: this.$t('button.know'),
        content: res?.msg,
        okType: 'danger',
        theme: 'round-button',
        onOk() {
          // that.cancelDirectiveApi()
          // this.$router.go(-1)
          this.showDialogVisible()
          this.dialogVisible = false
        },
      })
      // .then(() => {
      //   this.$router.go(-1)
      // })
    },

    // 验证码校验
    validator(val) {
      if (!val) {
        this.$message.error(
          this.$t(
            'serviceSupport.clearanceService.certificateQuery.mobileCodePlaceholder'
          )
        )
        return false
      } else {
        const reg = /^\d{6}$/.test(val)
        if (!reg) {
          this.$message.error(
            this.$t(
              'serviceSupport.clearanceService.certificateQuery.verificationCodeTip'
            )
          )
        }
        return reg
      }
    },
    showDialogVisible() {
      this.timer = setTimeout(() => {
        this.form = JSON.parse(
          JSON.stringify({
            mobile: '',
            mobileCode: '',
            businessType: '3', // 业务场景
            app: 'waybill', // 顺丰滑块需要
            countryCode: 'CN', // 手机默认国家,手机区号可能相同，故取国家二字码
          })
        )
        this.fetchMobileAreaCodeList()
        // this.form.phoneNumber = '';
        // this.form.validateCode = '';
        // this.$refs?.verifyFormRef?.resetFields();
      }, 0)
    },
  },
}
